import type { AreaCatalog } from '../area';
import type { facts as en } from '../en/facts';

export const facts = {
  'facts.word.quiet': 'ohne Bewegung',
  'facts.word.endPassed': 'überfällig',
  'facts.word.startPassed': 'Beginn überschritten',
  'facts.word.noRequester': 'verwaist',
  'facts.word.needsDoing': 'noch zu vergeben',
  'facts.word.dependents': 'hat abhängige Aufgaben',
  'facts.word.backPressure': 'wartende abhängige Aufgaben',
  'facts.word.committedButInert': 'zugesagt, aber ohne Bewegung',
  'facts.word.runningOnOldIntent': 'folgt einem alten Ziel',
  'facts.word.unattendedRisk': 'unbeachtetes Risiko',
  'facts.word.scheduleConflict': 'Terminkonflikt',
  'facts.word.tagged': 'trägt einen Tag',
  'facts.word.inStage': 'steht in einer Phase',
  'facts.condition.pastDays': {
    one: '{fact} seit über {count} Tag',
    other: '{fact} seit über {count} Tagen',
  },
  'facts.condition.tagged': 'trägt #{tag}',
  'facts.condition.inStage': 'in {stage}',
  'facts.day': '{day}',
  'facts.line.quiet': {
    one: 'Seit {count} Tag ohne Bewegung',
    other: 'Seit {count} Tagen ohne Bewegung',
  },
  'facts.line.endPassed': {
    one: '{count} Tag überfällig, Ende {end}',
    other: '{count} Tage überfällig, Ende {end}',
  },
  'facts.line.startPassed': 'Nicht begonnen, Beginn {start}',
  'facts.line.noRequester': 'Verwaist',
  'facts.line.needsDoing': 'Noch zu vergeben',
  'facts.line.dependents': {
    one: '{count} abhängige Aufgabe',
    other: '{count} abhängige Aufgaben',
  },
  'facts.line.backPressure': {
    one: '{count} bereite abhängige Aufgabe wartet',
    other: '{count} bereite abhängige Aufgaben warten',
  },
  'facts.line.scheduleConflict': 'Eine Abhängigkeit wird erst nach dem Ende {end} fertig',
  'facts.line.scheduleConflictBoth':
    'Eine Abhängigkeit wird erst am {arrives} fertig, nach dem Ende {end}',
  'facts.line.committedButInert': {
    one: 'Aktiv, seit {count} Tag ohne Bewegung',
    other: 'Aktiv, seit {count} Tagen ohne Bewegung',
  },
  'facts.line.runningOnOldIntent': {
    one: 'Ziel seit {count} Tag nicht gepflegt',
    other: 'Ziel seit {count} Tagen nicht gepflegt',
  },
  'facts.line.unattendedRisk': {
    one: '{count} bereite abhängige Aufgabe wartet, unbeachtet',
    other: '{count} bereite abhängige Aufgaben warten, unbeachtet',
  },
  'facts.line.tagged': 'Trägt #{tag}',
  'facts.line.inStage': 'In {stage}',
  'facts.provenance.seats': 'aus der Verantwortung und Zuständigkeit übernommen',
  'facts.provenance.flowRule': 'laut {flow}: {condition}',
  'facts.provenance.boardRule': 'laut Regel dieses Boards: {condition} = {grade}',
  'facts.provenance.declaredBy': 'angegeben von {principal}',
  'facts.provenance.cycle': 'aus den Abhängigkeiten berechnet',
  'facts.provenance.relayed': 'über eine Abhängigkeit weitergegeben',
  'facts.grade.notice': 'Hinweis',
  'facts.grade.warning': 'Warnung',
  'facts.grade.critical': 'kritisch',
  'facts.digest.deadlock': 'Eine gegenseitige Blockade',
  'facts.digest.deadlockUnknown': 'Eine gegenseitige Blockade mit unbekannten Beteiligten',
  'facts.digest.cycle': 'Ein Kreis aus Abhängigkeiten',
  'facts.digest.cycleUnknown': 'Ein Kreis aus Abhängigkeiten mit unbekannten Beteiligten',
  'facts.digest.relayed': '{origin}: {statement}',
  'facts.digest.anItem': 'eine Aufgabe',
  'facts.digest.aStatement': 'eine Aussage',
  'facts.digest.hidden': 'eine Aufgabe, die du nicht sehen kannst',
} as const satisfies AreaCatalog<typeof en>;
